import axios from "axios";
import Config from "config";
import BadRequestError from "repository/error/BadRequestError";
import FailedRequestError from "repository/error/FailedRequestError";
import Cookies from "js-cookie";

const Api = axios.create({
    baseURL: Config.api,
    headers: {
        'Content-Type': 'application/json',
    },
});

/**
 * Middleware that refreshes jwt from Cookies before every request.ß
 */
Api.interceptors.request.use(
    config => {
        const token = Cookies.get("token");

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        } else {
            delete Api.defaults.headers.common.Authorization;
        }
        return config;
    },
    error => Promise.reject(error)
);

Api.interceptors.response.use(
    res => res,
    err => {
        const {url} = err.config;
        if (err.response) {
            // The request was made and the server responded with a status code out of the range 2xx
            switch (err.response.status) {
                case 400: throw new BadRequestError(url);
                case 401: window.location = Config.dashboard; break;
                default: throw new FailedRequestError(`Something went wrong (${err.response.status})`)
            }
        } else if (err.request) {
            // The request was made but no response was received. `error.request` is an instance of XMLHttpRequest
            throw new FailedRequestError("No response")
        } else {
            // Something happened in setting up the request that triggered an Error
            throw new FailedRequestError("Could not make request");
        }
    }
)

export const ping = async () => {
    try {
        await fetch('https://api.speedweaver.co.uk', {mode: 'no-cors'});
        return true;
    } catch (e) {
        return false;
    }
}

export default Api;